import React, { useState, useEffect } from "react"
import { spoonacularApi } from "../../services/api/apiParams"
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHeart, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import "./quickView.css"
function QuickView({
  show,
  handleClose,
  recipe,
  handleShowAdd,
  handleShowAddMeal,
  addRecipe,
  addRecipeMealPlanner,
  favoritesCard,
  deleteFav,
}) {
  const [recipeInfo, setRecipeInfo] = useState({})

  useEffect(() => {
    const fetchRecipeInfo = async () => {
      //favoritesCard for favorites page cards
      const recipeId = favoritesCard ? recipe.api_id : recipe.id
      const res = await spoonacularApi.get(
        `https://api.spoonacular.com/recipes/${recipeId}/information`
      )
      setRecipeInfo(res.data)
    }
    fetchRecipeInfo()
  }, [recipe])
  return (
    <>
      <Modal show={show} onHide={handleClose} className='modal'>
        <Modal.Header closeButton>
          <Modal.Title>{recipeInfo.title}</Modal.Title>
        </Modal.Header>
        <div className='imgBox'>
          <img src={recipeInfo.image} alt='recipe' className='img-fluid' />
        </div>
        <Modal.Body>
          <span className='recipeProp'>Title: </span> {recipeInfo.title}
        </Modal.Body>
        {recipeInfo.cuisines?.length > 0 && (
          <Modal.Body>
            <span className='recipeProp'>Cuisines: </span>
            {recipeInfo.cuisines.join(", ")}
          </Modal.Body>
        )}
        {/* recipeInfo.diets?.length > 0 */}
        {recipeInfo.diets && recipeInfo.diets.length > 0 && (
          <Modal.Body>
            {" "}
            <span className='recipeProp'>Diets: </span>
            {recipeInfo.diets.join(", ")}
          </Modal.Body>
        )}
        {!recipeInfo.sourceUrl && (
          <Modal.Body>
            <span className='recipeProp'>
              Get more info about the recipe here:
            </span>
            <a href={recipeInfo.sourceUrl} target='_blank' rel='noreferrer'>
              {recipeInfo.sourceName}
            </a>
          </Modal.Body>
        )}

        <Modal.Footer>
          <Modal.Body>
            <span className='recipeProp'>likes: </span>
            {recipeInfo.aggregateLikes}
          </Modal.Body>

          {recipeInfo.readyInMinutes > 0 && (
            <Modal.Body>
              <span className='recipeProp'>Preparation time: </span>{" "}
              {recipeInfo.readyInMinutes} min
            </Modal.Body>
          )}
        </Modal.Footer>

        <Modal.Footer>
          <Button
            className='myBtn'
            onClick={(e) => {
              setRecipeInfo({})
              handleClose()
            }}>
            Close
          </Button>
          {favoritesCard && (
            <Button
              className='myBtn'
              onClick={() => {
                handleClose()
                deleteFav(recipe.id)
              }}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          )}
          {!favoritesCard && (
            <>
              <Button
                className='myBtn'
                onClick={() => {
                  handleClose()
                  handleShowAdd()
                  addRecipe(recipe)
                  // e.currentTarget.blur()
                }}>
                <FontAwesomeIcon icon={faHeart} />
              </Button>
              <Button
                className='myBtn'
                onClick={() => {
                  handleClose()
                  handleShowAddMeal()
                  addRecipeMealPlanner(recipe)
                  // e.currentTarget.blur()
                }}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default QuickView
